export default "__VITE_ASSET__9b361c1a__"